import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
// import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined";
// import { Navigate } from "react-router-dom";
// import TripBillingList from "../components/tripList";
// import { TripDetailsView } from "../components/detailsView";

const TripBillingReportRoute = {
  icon: DirectionsCarIcon,
  name: "Trip Management",
  link: "/trip-management",
  path: "trip-management",
  index: 9,
  element: "",
  superAdminView: false,
  children: [
    // {
    //   path: "trip-billing-report",
    //   element: <TripBillingList />,
    //   permission: "Trip Billing Report-Read",
    //   name: "Trip Billing Report",
    //   index: 6,
    //   link: "trip-management/trip-billing-report",
    //   icon: BadgeOutlinedIcon,
    // },
    // {
    //   path: "trip-billing-report/:id",
    //   element: <TripDetailsView />,
    // },
    // {
    //   path: "",
    //   element: <Navigate to="trip-billing-report" replace />,
    // },
  ],
};
export default TripBillingReportRoute;
